// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3AM3G","title":"ClientInsurance_title__2bYoS","itemText":"ClientInsurance_itemText__2wFRz"};